import axios from 'axios';
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
   columns : [],
   
};

export const EventSlice = createSlice({

  name: 'events',
  initialState,
  reducers: {

    load : (state, action) => {
      console.log('EventSlice:load')
      console.log(action.payload)
      const data = action.payload
      return {
          ...state,
          ...data
      }
    }
   }
});


export const {
  load
} = EventSlice .actions;

export default EventSlice.reducer;
